import { VueQueryPlugin } from "@tanstack/vue-query";
import { queryClient } from "@verbleif/lib/src/composables/Query/queryClient";
import i18n from "@verbleif/lib/src/translations/i18n";
import { installDevInteractionTiming, installDevNavigationTiming } from "@web/composables/Perf/devInteractionTiming";
import { hydratePropertyStateMapsFromQueryClient } from "@web/features/Tasks/TaskExtraData/propertyStateMaps";
import { createApp } from "vue";
import App from "../App.vue";
import router from "./plugin/router";
import { restorePersistedQueries } from "./queryPersister";

const app = createApp(App);
installDevInteractionTiming(app);
installDevNavigationTiming(router);

export { queryClient };

localStorage.removeItem("sidebarPropertyStatesCache");
localStorage.removeItem("taskPropertyStatesCache");

void restorePersistedQueries.then(() => {
  hydratePropertyStateMapsFromQueryClient();
});

app.use(router);
app.use(i18n);
app.use(VueQueryPlugin, { queryClient });

export default app;
